import ufeApi from 'services/api/ufeApi';
const cookieUtils = require('utils/Cookies').default;
const UserUtils = require('utils/User').default;
// https://confluence.sephora.com/wiki/display/ILLUMINATE/Update+preferred+zip+code

function updatePreferredZipCode(args) {
    let url = '/api/users/profile/preferredZipCode';
    const isUserAnonymous = UserUtils.isAnonymous();
    const { enableProfileBIGroup = false } = Sephora.configurationSettings;
    const isRCPSProfileBiGroupAPIEnabled = cookieUtils.isRCPSProfileBiGroupAPIEnabled();

    if (enableProfileBIGroup && isRCPSProfileBiGroupAPIEnabled && !isUserAnonymous) {
        url = '/gway/v2/users/profile/preferredZipCode';
    }

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(args)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default updatePreferredZipCode;
